import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ObjectFormEdit } from "./ui";

export const ObjectEditRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `${routes.objects.edit()}`,
    element: createElement(ObjectFormEdit),
    children: [...rest],
  };
};
